// Version : 0.0.3
// Author : VIGNESH
// LastEdit : VISHAL BHARATHI
// Last ADD : ENACH REPORT EXPORT REDUCER REMOVED
// MODIFIED DATE: 19-09-2025

import ENACHReportActionTypes from './enachReport.types';
const INITIAL_STATE = {
	// FETCH ENACH REPORT RESPONSE
	fetchENACHReportListResponse: null,
};

const enachReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** *********************  START OF GET ENACH REPORT  ******************** */
		case ENACHReportActionTypes.FETCH_ENACH_REPORT_SUCCESS:
			return {
				...state,
				fetchENACHReportListResponse: action.payload,
			};

		case ENACHReportActionTypes.FETCH_ENACH_REPORT_FAILURE:
			return { ...state, fetchENACHReportListResponse: action.payload };

		case ENACHReportActionTypes.FETCH_ENACH_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchENACHReportListResponse: null,
			};
		/** *********************  END OF GET ENACH REPORT  ******************** */

		default:
			return state;
	}
};

export default enachReducer;
